import { useEffect, useState } from "react";

const messages = [
  "FREE USA SHIPPING ON ALL ORDERS",
  "FAMILY OWNED & OPERATED SINCE 1994",
  "COMPLIMENTARY GIFT WRAPPING",
];

export default function AnnouncementBar() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % messages.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-2.5 flex items-center justify-center">
        <p
          key={index}
          className="font-label text-[11px] md:text-xs tracking-[0.28em] uppercase text-center animate-fade-in"
        >
          {messages[index]}
        </p>
      </div>
    </div>
  );
}